import React from 'react'
import _ from 'common-tools/LodashHelper'

export const ActionStopBubbleClick = (onClick) => {
  return (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()

    if (_.isFunction(onClick) === true) {
      onClick(e)
    }
  }
}

export function ActionLink (props) {
  const { 'data-tid': testId = '', children, stopBubbleClicks = true, className, onClick, ...rest } = props
  return <a
    data-tid={testId}
    onClick={stopBubbleClicks ? ActionStopBubbleClick(onClick) : onClick}
    href='#'
    className={className}
    {...rest}
  >
    {children}
  </a>
}
